import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, CLUB_LOGO } from "@/lib/api";
import { Calendar as CalIcon, ArrowRight } from "lucide-react";

export default function News() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14" data-testid="news-page">
      <div className="mb-10">
        <span className="text-xs tracking-[0.3em] uppercase text-[#1E3A8A] font-bold">La vie du club</span>
        <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-[#0F172A] tracking-tighter" style={{ fontFamily: "Outfit" }}>
          Actualités<span className="text-[#DC2626]">.</span>
        </h1>
        <p className="mt-3 text-[#475569] max-w-2xl">
          Résultats, annonces, événements : toute l'actualité officielle de Villeurbanne United.
        </p>
      </div>

      {items.length === 0 && <div className="text-[#475569]">Aucune actualité pour l'instant.</div>}

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((n) => (
          <Link key={n.id} to={`/actualites/${n.id}`} data-testid={`news-item-${n.id}`} className="group border border-[#E2E8F0] rounded-lg overflow-hidden hover:-translate-y-1 hover:border-[#1E3A8A] transition-all duration-200 bg-white">
            <div className="aspect-[16/10] bg-slate-100 overflow-hidden">
              {n.image_url ? (
                <img src={n.image_url} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              ) : (
                <div className="w-full h-full bg-gradient-to-br from-[#1E3A8A] to-[#0F172A] flex items-center justify-center">
                  <img src={CLUB_LOGO} alt="VU" className="h-24 w-24 object-contain opacity-80" />
                </div>
              )}
            </div>
            <div className="p-5">
              <div className="text-[10px] tracking-[0.2em] uppercase text-[#D97706] font-bold flex items-center gap-2">
                <CalIcon size={12} /> {new Date(n.published_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
              </div>
              <h3 className="mt-2 font-bold text-[#0F172A] group-hover:text-[#1E3A8A] transition-colors" style={{ fontFamily: "Outfit" }}>{n.title}</h3>
              <p className="mt-2 text-sm text-[#475569] line-clamp-3">{n.excerpt}</p>
              <div className="mt-4 text-xs font-semibold text-[#1E3A8A] inline-flex items-center gap-1 group-hover:text-[#DC2626] transition-colors">
                Lire la suite <ArrowRight size={12} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
